module.exports = __webpack_public_path__ + "1b43274d.png";